<template>
  <div class="common-coupon-components">
    <ym-popup class="common-coupon-popup"
              v-model="visible"
              get-container="body"
    >
      <div v-if="info"
           class="common-coupon-container"
      >
        <div class="common-coupon-info">
          <div class="common-coupon-info-price">
            <span>¥</span>
            <span class="price">{{ info.coupon.price }}</span>
          </div>
          <div class="common-coupon-info-title">
            {{ info.coupon.title }}
          </div>
          <div class="common-coupon-info-desc">
            {{ info.coupon.desc }}
          </div>
        </div>
        <div class="common-coupon-action">
          <count-down-block class="common-coupon-action-count-down"
                            :end-time="info.coupon.countDown.endTime"
                            suffix="后失效"
          />
          <div class="common-coupon-action-use-btn"
               @click="handleUse(info.btn.path)"
          >
            {{ info.btn.text }}
          </div>
          <div class="common-coupon-action-hint">
            {{ info.desc }}
          </div>
        </div>
      </div>
      <div class="common-coupon-popup-close"
           @click.stop="handleClose(visible)"
      >
        <ym-icon name="round-close" />
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';
  import CountDownBlock from '@/components/CountDownBlock';
  import { locationHref } from '@/utils';
  import validator from '@/utils/validator';

  export default {
    name: 'CommonCouponPopup',
    components: {
      'ym-popup': Popup,
      CountDownBlock,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      info: {
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
      needMobile(val) {
        this.submitBtnDisabled = val;
      },
    },
    methods: {
      handleUse(path) {
        locationHref(path);
      },
      handleClose() {
        this.visible = false;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .common-coupon {
    &-popup {
      background: transparent;
    }
    &-container {
      box-sizing: border-box;
      width: 630px;
      height: 666px;
      padding-top: 170px;
      padding-bottom: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      background: url('~@/assets/img/coupon_popup/bg.png') no-repeat;
      background-size: 100% 100%;
    }
    &-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      &-price {
        display: flex;
        align-items: flex-end;
        color: #fa405e;
        font-size: @font-size-medium;
        line-height: 1;
        .price {
          font-size: 80px;
          font-weight: @font-weight-strong;
          line-height: 0.8;
        }
      }
      &-title {
        margin-top: 22px;
        color: @color-text-base;
        font-size: @font-size-medium;
        font-weight: @font-weight-strong;
        line-height: 1;
      }
      &-desc {
        box-sizing: border-box;
        width: fit-content;
        height: 40px;
        margin-top: @size-small;
        padding: 8px 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-small;
        line-height: 1;
        background: #fa405e;
        border-radius: 20px;
      }
    }
    &-action {
      display: flex;
      flex-direction: column;
      align-items: center;
      &-count-down {
        font-size: @font-size-base;
        /deep/ .million-read-count-down-block-suffix {
          margin-left: 10px;
        }
      }
      &-use-btn {
        width: 240px;
        height: 88px;
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-base;
        font-size: @font-size-medium;
        font-weight: @font-weight-strong;
        line-height: 1.1;
        background: linear-gradient(to bottom, #ffe7a4, #ffd540);
        border-radius: 44px;
      }
      &-hint {
        margin-top: @size-small;
        color: @color-white;
        font-size: @font-size-extra-small;
        line-height: 1;
      }
    }
    &-popup-close {
      position: absolute;
      bottom: -2 * @size-extra-medium;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: @size-large;
      height: @size-large;
      font-size: @size-large;
      color: @color-placeholder;
    }
  }

</style>
